// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ANPg","rootNoMargin":"styles_rootNoMargin__3RAI1"};